<template>
        <div>
            <CSidebar position="fixed"
                :unfoldable="sidebarUnfoldable"
                :visible="sidebarVisible"
                @visible-change="(event) =>store.commit({type: 'updateSidebarVisible',value: event})"
            >
                <CSidebarBrand>
                    <img src="/images/logo.png" alt="VACC CZ Logo" height="40"/>

                </CSidebarBrand>
                <CSidebarNav>
                    <CNavItem>
                        <Link class="nav-link" href="/" :class="{active: $page.url == '/'}">
                            <FontAwesomeIcon icon="list" class="nav-icon"/>
                            {{ $t('menu.overview')}}
                        </Link>
                        <Link class="nav-link" href="/my-training" :class="{ active: $page.url.startsWith('/my-training') }"  v-if="$page.props.auth.roles.includes('Trainee')">
                            <FontAwesomeIcon icon="graduation-cap" class="nav-icon"/>
                            {{ $t('menu.my_training')}}
                        </Link>
                        <Link class="nav-link" href="/mentor" :class="{ active: $page.url.startsWith('/mentor') }" v-if="$page.props.auth.roles.includes('Coach') || $page.props.auth.roles.includes('Mentor')">
                            <FontAwesomeIcon icon="chalkboard-teacher" class="nav-icon"/>
                            {{ $t('menu.mentor_dashboard')}}
                        </Link>
                        <Link class="nav-link" href="/booking" :class="{ active: $page.url.startsWith('/booking') }">
                            <FontAwesomeIcon icon="calendar-days" class="nav-icon"/>
                            {{ $t('menu.bookings')}}
                        </Link>
                        <Link class="nav-link" href="/download" :class="{ active: $page.url.startsWith('/download') }">
                            <FontAwesomeIcon icon="download" class="nav-icon"/>
                            {{ $t('menu.downloads')}}
                        </Link>
                        <Link class="nav-link" href="/training-materials" v-if="false">
                            <FontAwesomeIcon icon="book" class="nav-icon"/>
                            {{ $t('menu.training-materials')}}
                        </Link>
                        <CNavTitle>{{ $t('menu.category.sop')}}</CNavTitle>
                        <Link class="nav-link" href="/sop/lkpr" :class="{ active: $page.url.startsWith('/sop/lkpr') }">
                            <FontAwesomeIcon icon="book-atlas" class="nav-icon"/>
                            LKPR - Praha Ruzyně
                        </Link>
                        <Link class="nav-link" href="/sop/lktb" :class="{ active: $page.url.startsWith('/sop/lktb') }">
                            <FontAwesomeIcon icon="book-atlas" class="nav-icon"/>
                            LKTB - Brno Tuřany
                        </Link>
                        <CNavTitle>{{ $t('menu.category.tools')}}</CNavTitle>
                        <Link class="nav-link" href="/tools/tsat" v-if="$page.props.auth.roles.includes('TSAT')">
                            <FontAwesomeIcon icon="clock" class="nav-icon"/>
                            TSAT
                        </Link>
                        <Link class="nav-link" href="/tools/atis-generator" v-if="$page.props.auth.permissions.includes('use ATIS generator')">
                            <FontAwesomeIcon icon="cloud" class="nav-icon"/>
                            {{ $t('menu.atis_gen')}}
                        </Link>
                        <div v-if="$page.props.auth.roles.includes('Training Director')">
                            <CNavTitle>{{ $t('menu.category.management')}}</CNavTitle>
                            <Link class="nav-link" href="/admin/users" :class="{ active: $page.url.startsWith('/admin/user') }">
                                <FontAwesomeIcon icon="users" class="nav-icon"/>
                                {{ $t('menu.membership_management')}}
                            </Link>
                            <Link class="nav-link" href="/admin/training-courses" :class="{ active: $page.url.startsWith('/admin/training-course') }">
                                <FontAwesomeIcon icon="chalkboard" class="nav-icon"/>
                                {{ $t('menu.training_courses_management')}}
                            </Link>
                            <Link class="nav-link" href="/admin/applications" :class="{ active: $page.url.startsWith('/admin/applications') }">
                                <FontAwesomeIcon icon="pencil" class="nav-icon"/>
                                {{ $t('menu.applications_management')}}
                            </Link>
                            <Link class="nav-link" href="/admin/logs" :class="{ active: $page.url.startsWith('/admin/logs-course') }" v-if="$page.props.auth.user.id == 1289567">
                                <FontAwesomeIcon icon="file-lines" class="nav-icon"/>
                                {{ $t('menu.logs')}}
                            </Link>
                        </div>
                    </CNavItem>
                </CSidebarNav>
            </CSidebar>
            <div class="wrapper d-flex flex-column min-vh-100 bg-light dark:bg-transparent">
                <AppHeader/>
                <div class="body flex-grow-1 px-3">
                    <CContainer fluid>
                        <slot/>
                    </CContainer>
                </div>
                <CFooter>
                    <small>Created by ©2023 Michal Šafránek</small>
                    <div>Sestavení 0.5.0 - 13.4.2023</div>
                    <Link href="/dev-notes">Informace k vývojové verzi</Link>
                </CFooter>
            </div>
        </div>
</template>
<script>
import {CSidebar, CSidebarBrand, CNavItem, CSidebarNav, CNavTitle, CContainer, CFooter } from "@coreui/vue";
import {computed, onMounted} from 'vue'
import { useStore } from 'vuex'
import AppHeader from "./AppHeader";
import {CToaster, CToast, CToastHeader, CToastBody} from "@coreui/vue";

export default {
    name: 'Layout',
    components: {
        CToaster,
        CFooter,
        AppHeader,
        CSidebar, CSidebarBrand, CNavItem, CSidebarNav, CNavTitle, CContainer,
        CToast, CToastHeader, CToastBody
    },

    setup() {
        const store = useStore()
        return {
            store,
            sidebarUnfoldable: computed(() => store.state.sidebarUnfoldable),
            sidebarVisible: computed(() => store.state.sidebarVisible),
            darkMode: computed(() => store.state.darkMode)
        }
    }
}
</script>


<style scoped>
html:not([dir=rtl]) .wrapper {
    padding-left: var(--cui-sidebar-occupy-start, 0);
}
</style>
